import * as PropTypes from "prop-types"
import { applyFilters } from "helpers/filterCars"
import { useContext } from "react"
import { RentingContext } from "scenes/RentingScene/RentingContext"
import useFilteredOptions from "hooks/useFilteredOptions"
import Typography from "components/styled/Typography"
import { useT } from "react-polyglot-hooks"
import { capitalizeFirstLetter as capitalize } from "helpers/formatter"
import Selector from "../Selector"

export default function FuelSelector({ field, value, show, handleChange, label, col }) {
  const t = useT()
  const { cars } = useContext(RentingContext)

  const options = useFilteredOptions(field, () =>
    [
      { value: "diesel", label: capitalize(t("car.fuel.diesel")) },
      { value: "petrol", label: capitalize(t("car.fuel.petrol")) },
      { value: "hybrid", label: capitalize(t("car.fuel.hybrid")) }
    ].filter(option => applyFilters(cars, { [field]: option.value }).length > 0)
  )

  if (!show) return null

  return (
    <>
      {label && (
        <Typography el="label" className="mb-2">
          {label}
        </Typography>
      )}
      <Selector field={field} initialValue={value} options={options} handleChange={handleChange} multiple col={col} />
    </>
  )
}

FuelSelector.defaultProps = {
  show: true,
  label: null,
  field: "fuel",
  value: [],
  col: { xs: 3, lg: 6 }
}

FuelSelector.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  show: PropTypes.bool,
  label: PropTypes.string,
  field: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  col: PropTypes.shape({
    xs: PropTypes.number,
    lg: PropTypes.number
  })
}
